export default "__VITE_ASSET__1c7e5669__"